import { render } from "./Files.vue?vue&type=template&id=42d474b0&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-42d474b0"

export default script